// Footer.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Components/CSS/Global.css";

const Footer = () => {
  const [year, setYear] = useState(null);

  useEffect(() => {
    const getISTYear = () => {
      const now = new Date();
      const utcOffset = now.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
      const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5:30
      const istTime = new Date(now.getTime() + utcOffset + istOffset);
      setYear(istTime.getFullYear());
    };

    getISTYear();
  }, []);

  return (
    <>
      <div className="call">
        <div className="card">
          <div className="card-content">
            <h2 className="card-title">Get in Touch with Us!</h2>
            <p className="card-text">
              Have a question or need support? We're here to help! Drop us a
              message and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="card-btn">
            <Link to="/contact-us" className="card-button">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
      <footer>
        <div className="footer-container">
          <div className="footer-section company-info">
            <h4>About Company.</h4>
            <p>
              100Billion Tech is a leading technology solutions provider
              dedicated to transforming businesses through innovative digital
              solutions.
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/100billiontech">
                <i className="fab fa-facebook-f"></i>
              </a>
              {/* <a href="#"><i className="fab fa-twitter"></i></a> */}
              <a
                href="https://www.instagram.com/100billiontech"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://in.linkedin.com/company/100billion-tech">
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
            </div>
          </div>
          <div className="footer-section support">
            <h4>Support.</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy policy</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund policy</Link>
              </li>
              <li>
                {" "}
                <Link to="/terms-and-conditions">Terms and conditions</Link>
              </li>
            </ul>
          </div>
          <div className="footer-section services">
            <h4>Services.</h4>
            <ul>
              <li>
                <Link to="/website-development">Website Development</Link>
              </li>
              <li>
                <Link to="/application-development">Mobile Development</Link>
              </li>
              <li>
                <Link to="/get-your-online-store">E-commerce Website</Link>
              </li>
              <li>
                <Link to="/digital-marketing">Digital Marketing</Link>
              </li>
              <li>
                <Link to="/google-ads">Google Ads</Link>
              </li>
              <li>
                <Link to="/meta-ads">Meta Ads</Link>
              </li>
            </ul>
          </div>
          <div className="footer-section contact">
            <h4>Contact.</h4>
            <p>
              <i className="fas fa-map-marker-alt"></i> E-10 4th floor, Nemi
              Krishna Building, Jethwa Nagar Opposite Bajaj School, Kandivali
              West, 400067
            </p>
            <p>
              <a
                className="changetelephonetonormalcolor"
                href="tel:+917715863833"
              >
                <i className="fas fa-phone"></i> +91 8433-803-555
              </a>
            </p>

            <p>
              <i className="fas fa-envelope"></i> info@100billiontech.com
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright &copy; 100billion Tech {year} All Rights Reserved</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
